module.exports = __webpack_public_path__ + "static/blanket_flower_16x20-14caeb58edd3e60932598162f509fa11.jpg";